var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2871 16.0727C45.0743 14.9854 44.1052 14.1818 42.9707 14.1818H9.02887C7.89432 14.1818 6.92523 14.9854 6.71251 16.0727L4.72705 26V28.3636C4.72705 29.6636 5.79069 30.7272 7.09069 30.7272V42.5454C7.09069 43.8454 8.15432 44.9091 9.45432 44.9091H28.3634C29.6634 44.9091 30.7271 43.8454 30.7271 42.5454V30.7272H40.1816V42.5454C40.1816 43.8454 41.2452 44.9091 42.5452 44.9091C43.8452 44.9091 44.9089 43.8454 44.9089 42.5454V30.7272C46.2089 30.7272 47.2725 29.6636 47.2725 28.3636V26L45.2871 16.0727ZM25.9998 40.1818H11.818V30.7272H25.9998V40.1818ZM9.45432 11.8182H42.5452C43.8452 11.8182 44.9089 10.7545 44.9089 9.45452C44.9089 8.15452 43.8452 7.09088 42.5452 7.09088H9.45432C8.15432 7.09088 7.09069 8.15452 7.09069 9.45452C7.09069 10.7545 8.15432 11.8182 9.45432 11.8182Z",
    fill: "url(#paint0_linear_538_2980)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_2980",
    x1: 4.72705,
    y1: 44.9091,
    x2: 42.2844,
    y2: 2.65703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628533,
    stopColor: "#F23A3A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.976a6bed0692074af46ccb9f680a23ba.svg";
export { ForwardRef as ReactComponent };